import { TFunction } from 'i18next';
import Input from '@lib/components/Input/Input';
import { FieldItem } from '@lib/interfaces/form';
import { getFieldValidation } from '@lib/utils/validationUtils';
import ApiTokenFieldNames from '@lib/enums/fieldNames/apiTokenFieldNames';

type FormFieldsArgs = {
  t: TFunction<'translation', undefined>;
};

export const defaultValues = {
  [ApiTokenFieldNames.Label]: '',
};

export default function getApiTokenFormFields({
  t,
}: FormFieldsArgs): FieldItem[] {
  return [
    {
      name: ApiTokenFieldNames.Label,
      label: t('token-label'),
      element: Input,
      validation: getFieldValidation({ t }),
    },
  ];
}
